export default {
  fieldset: {
    border: 0,
    padding: 0,
    margin: 0,
    minWidth: 0,
    pointerEvents: 'none',
  },
};
